import { Box, Button, Stack, Text, chakra } from '@chakra-ui/react';
import * as React from 'react';

import { InPersonIndicator } from '@/components/EventVenueIndicator';

export const InPerson: React.FC<{
  onClickEdit?: () => void;
  address: {
    administrativeArea: string | null;
    country: string | null;
    locality: string | null;
    name: string | null;
    postalCode: string | null;
    streetAddress: string | null;
    streetAddressLine2: string | null;
  } | null;
  description: string | null;
}> = ({ onClickEdit, address, description }) => {
  const addressQuery = address
    ? [
        address.streetAddress,
        address.streetAddressLine2,
        address.locality,
        address.administrativeArea,
        address.country,
        address.postalCode,
      ]
        .filter((value) => value)
        .join(', ')
    : null;

  return (
    <Stack spacing="3">
      <InPersonIndicator address={address} />

      {addressQuery && (
        <chakra.iframe
          height="xs"
          borderRadius="lg"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/place?key=${
            process.env.NEXT_PUBLIC_GOOGLE_MAPS_EMBED_KEY
          }&q=${encodeURIComponent(addressQuery)}`}
        />
      )}

      {description && (
        <Box p="4" bg="gray.50" borderRadius="lg">
          <Text>{description}</Text>
        </Box>
      )}

      {address &&
        onClickEdit &&
        (!address.streetAddress ||
          !address.locality ||
          !address.administrativeArea) && (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            px="4"
            py="3"
            bg="gray.100"
            borderRadius="lg"
          >
            <Text>Complete the in-person venue address</Text>
            <Button onClick={onClickEdit}>Edit Address</Button>
          </Stack>
        )}
    </Stack>
  );
};
